import { type FieldValues, type Path, type PathValue } from 'react-hook-form';

import { useFormElement } from '../useFormElement';

import { BaseCodeInput, type BaseCodeInputProps } from './BaseCodeInput';

export type CodeInputProps<T extends FieldValues, FP extends Path<T>> = Omit<
	BaseCodeInputProps,
	'hasError' | 'name' | 'onChange' | 'ref' | 'value'
> & {
	defaultValue?: PathValue<T, FP>;
	name: FP;
};

export function CodeInput<T extends FieldValues, FP extends Path<T> = Path<T>>(props: CodeInputProps<T, FP>) {
	const {
		field,
		fieldState: { error }
	} = useFormElement<T, FP>({
		defaultValue: props.defaultValue,
		name: props.name
	});

	return <BaseCodeInput {...props} {...field} hasError={!!error} />;
}
